import { createContext } from 'react';

export const AssessmentContext = createContext({
  assessment: {},
  setAssessment: () => {},
});